import React from "react";
import "../../../css/Terms.css";
import { Default } from "../../layouts/default";
import { Link } from "react-router-dom";

function TermsofServices() {
  return (
    <Default>
      <section className="Terms-Services">
        <div className="container">
          <div className="row">
            <div className="col-md-10">
              <h1 className="Terms-Heading">
                Website Terms and Conditions of Use
              </h1>

              <h2 className="Terms-twoHeading">1. Terms</h2>

              <p className="Para-Terms">
                By accessing this Website, accessible from
                https://bookvenue.app, you are agreeing to be bound by these
                Website Terms and Conditions of Use and agree that you are
                responsible for the agreement with any applicable local laws. If
                you disagree with any of these terms, you are prohibited from
                accessing this site. The materials contained in this Website are
                protected by copyright and trade mark law.
              </p>

              <h2 className="Terms-twoHeading">2. Use License</h2>

              <p className="Para-Terms">
                Permission is granted to temporarily download one copy of the
                materials on bookvenue's Website for personal, non-commercial
                transitory viewing only. This is the grant of a license, not a
                transfer of title, and under this license you may not:
              </p>

              <ul>
                <li className="list-Terms">modify or copy the materials;</li>
                <li className="list-Terms">
                  use the materials for any commercial purpose or for any public
                  display;
                </li>
                <li className="list-Terms">
                  attempt to reverse engineer any software contained on
                  bookvenue's Website;
                </li>
                <li className="list-Terms">
                  remove any copyright or other proprietary notations from the
                  materials; or
                </li>
                <li className="list-Terms">
                  transferring the materials to another person or "mirror" the
                  materials on any other server.
                </li>
              </ul>

              <p className="Para-Terms">
                This will let bookvenue to terminate upon violations of any of
                these restrictions. Upon termination, your viewing right will
                also be terminated and you should destroy any downloaded
                materials in your possession whether it is printed or electronic
                format. These Terms of Service has been created with the help of
                the{" "}
                <Link to="https://www.termsofservicegenerator.net">
                  Terms Of Service Generator
                </Link>
                .
              </p>

              <h2 className="Terms-twoHeading">3. Disclaimer</h2>

              <p className="Para-Terms">
                All the materials on bookvenue's Website are provided "as is".
                bookvenue makes no warranties, may it be expressed or implied,
                therefore negates all other warranties. Furthermore, bookvenue
                does not make any representations concerning the accuracy or
                reliability of the use of the materials on its Website or
                otherwise relating to such materials or any sites linked to this
                Website.
              </p>

              <h2 className="Terms-twoHeading">4. Limitations</h2>

              <p className="Para-Terms">
                bookvenue or its suppliers will not be hold accountable for any
                damages that will arise with the use or inability to use the
                materials on bookvenue's Website, even if bookvenue or an
                authorize representative of this Website has been notified,
                orally or written, of the possibility of such damage. Some
                jurisdiction does not allow limitations on implied warranties or
                limitations of liability for incidental damages, these
                limitations may not apply to you.
              </p>

              <h2 className="Terms-twoHeading">5. Revisions and Errata</h2>

              <p className="Para-Terms">
                The materials appearing on bookvenue's Website may include
                technical, typographical, or photographic errors. bookvenue will
                not promise that any of the materials in this Website are
                accurate, complete, or current. bookvenue may change the
                materials contained on its Website at any time without notice.
                bookvenue does not make any commitment to update the materials.
              </p>

              <h2 className="Terms-twoHeading">6. Links</h2>

              <p className="Para-Terms">
                bookvenue has not reviewed all of the sites linked to its
                Website and is not responsible for the contents of any such
                linked site. The presence of any link does not imply endorsement
                by bookvenue of the site. The use of any linked website is at
                the user's own risk.
              </p>

              <h2 className="Terms-twoHeading">
                7. Site Terms of Use Modifications
              </h2>

              <p className="Para-Terms">
                bookvenue may revise these Terms of Use for its Website at any
                time without prior notice. By using this Website, you are
                agreeing to be bound by the current version of these Terms and
                Conditions of Use.
              </p>

              <h2 className="Terms-twoHeading">8. Your Privacy</h2>

              <p className="Para-Terms">Please read our Privacy Policy.</p>

              <h2 className="Terms-twoHeading">9. Governing Law</h2>

              <p className="Para-Terms">
                Any claim related to bookvenue's Website shall be governed by
                the laws of in without regards to its conflict of law
                provisions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Default>
  );
}

export default TermsofServices;
